<template>
  <div class="page_wrapper container-fluid campus_recruiting_area">
    <div class="row page_header campus_recruiting_header">
      <campus-recruiting-header />
    </div>
    <div class="row campus_recruiting_content">
      <!-- 說明會 -->
      <recruitment-orientation-details-content />
    </div>
  </div>
</template>
<script>
import CampusRecruitingHeader from '~components/pages/campus-recruiting/common/CampusRecruitingHeader'
import RecruitmentOrientationDetailsContent from '~components/pages/campus-recruiting/RecruitmentOrientationDetailsContent'
export default {
  name: 'RecruitmentOrientationDetails',
  routerName: 'Campus-recruiting:idRecruitment-orientation',
  components: {
    CampusRecruitingHeader,
    RecruitmentOrientationDetailsContent
  }
}
</script>
